import styled from 'styled-components';

export const LoaderContainer = styled.div`

  background: rgba(0, 0, 0, 0.5);

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 2;
`;
